
<template>
  <v-card elevation="6" class="my-4 mx-4">
    <template>
          <!-- <v-card-title class="mx-3" style="color:#AF8936"> -->

          <v-toolbar color="grey" dark dense flat>
            <h3>Consulta de logs</h3>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-card-text>
            <v-row justify="center">
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="num_cedula"
                  label="Ingresa numero de Cédula"
                  prepend-icon="mdi-magnify"
                  single-line
                  hide-details

                  >
                </v-text-field>
              </v-col>
            </v-row>
            <v-container>
            <v-btn block color="primary" @click="clickSearch()" class="my-1">
              Buscar
            </v-btn>
            </v-container>
          </v-card-text>


        <v-card>
          <div v-if="showAlert">
            <v-alert
              prominent
              outlined
              type="error"
             >
              <v-row align="center">
                <v-col class="grow hidden-xs-only">No se encontraron registros de la consulta.</v-col>
                <v-col class="grow hidden-sm-and-up">No hay registros.</v-col>
              </v-row>
            </v-alert>
          </div>


        <v-card-title  style="color:#AF8936">
          <h5>{{ titleTabla }}</h5>
        </v-card-title>
      <v-data-table
        :headers="headers"
        :items="logs"
        item-key="log"
        class="elevation-1"
        :loading="loading"
      >
      </v-data-table>
    </v-card>
    </template>

  </v-card>
</template>

<script>
import { mapGetters } from "vuex";//axios vuex
const Swal = require('sweetalert2');

  export default {
    data () {
      return {
        showAlert: false,
        titleTabla:'RESULTADOS:',
        headers: [
          //{ text: 'Log_name', align: 'left', value: 'log_name' },
          { text: 'Accion', value: 'description', sortable: true},
          //{ text: 'objeto', value: 'subject_id', sortable: true },
          { text: 'Modelo', value: 'subject_type', sortable: true},
          { text: 'User', value: 'user.name' },
          //{ text: 'causer_type', value: 'causer_type' },
          { text: 'Datos', value: 'properties' },
          // { text: 'Created', value: 'created_at' },
          // { text: 'Updated', value: 'updated_at' },
        ],
        loading:false,
        num_cedula:'',
        log_name:'',
        description:'',
        causer_id:'',
        description:'',
        subject_id: '',
        subject_type:'',
        causer_id: '',
        causer_type:'',
        properties: '',
        logs: [],
        //logsPaginate: [],
      }
    },

    created() {
        this.$store.commit("SET_LAYOUT", "dashboard-layout");
    },

    mounted(){
      this.searchLog();
    },

    computed: {
    ...mapGetters([
      "listLogs","resultLogs"
      ])
    },

    methods:{
      clickSearch(){
        this.titleTabla = 'RESULTADOS:'
        this.searchLog()
      },

      searchLog() {
        this.$store.dispatch("CONSULTAR_LOGS", {
          num_cedula: this.num_cedula,
        })
        .then((response) => {
          //this.dialog=false;
          this.logs = response.data.logs;
          this.showAlert = false;
          this.num_cedula = ''
          //this.roles = response.data;//usar response para datos, se puede usar getters
        })
        .catch(err => {
          console.log(err);
          this.showAlert = true;
          //this.showAlert(this.notification);
        });
      }
    },

  }
</script>
